import { useEffectiveWhitelabelId } from "./useEffectiveWhitelabelId";
import { useFeatureFlags } from "./useFeatureFlags";
import { useOrganizationId } from "./useOrganizationId";

/**
 * Resolves the `partnerAccess` feature flag for the currently effective
 * whitelabel. Encapsulates the whitelabel → organization → flag chain so
 * feature gates outside DashboardScreen don't need to thread three hooks.
 */
export function usePartnerAccessEnabled(): boolean {
  const whitelabelId = useEffectiveWhitelabelId();
  const organizationId = useOrganizationId(whitelabelId);
  const { partnerAccess } = useFeatureFlags(organizationId);
  return partnerAccess;
}
